export const EXPERIMENT_TO_RETRIEVE_CONTENT_FROM_V2_LANGSTON_API =
  "langston_search";
